



































































import { Component, Vue, Watch, Emit, Prop } from "vue-property-decorator";
import { PatientModel } from "@/models/patient";
import { patient as store } from "@/store/modules";
import { inject } from "inversify-props";
import { StockFilter, IStockService, StockOrderBy, OrderByMode } from "@/interfaces/Services";
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';
import { StockItemModel, StockItemStatus } from '@/models/stock';
import { DrugModel } from '../../models/drug';

enum StockItemActionable {
  Returnable = 'returnable'
}

@Component({
  components: {}
})
export class StockItemsTableExpandedCard extends Vue {
  @inject(DependencyIdentifiers.StockService)
  private stockService!: IStockService;

  @Prop({required: true, default: {}})
  private filter!: StockFilter;

  private isLoading = false;
  private componentKey = 0;
  private items: Array<StockItemModel> = [];
  private total = 0;
  private selected: StockItemModel[] = [];

  private get headers() {
    return [
      {
        text: this.$t('stock.columns.status'),
        align: "left",
        sortable: false,
        value: "status",
      },
      {
        text: this.$t('stock.columns.lotId'),
        align: "left",
        sortable: false,
        value: "lotId",
      },
      {
        text: this.$t('stock.columns.createdAt'),
        align: "left",
        sortable: false,
        value: "createdAt"
      },
      {
        text: this.$t('stock.columns.expiredAt'),
        align: "left",
        sortable: false,
        value: "expiredAt"
      },
      {
        text: this.$t('stock.columns.usedAt'),
        align: "left",
        sortable: false,
        value: "usedAt"
      },
      {
        text: this.$t('stock.columns.returnedAt'),
        align: "left",
        sortable: false,
        value: "returnedAt",
      },
    ];
  }

  private options = {
    page: 1,
    itemsPerPage: 10,
    sortBy: [],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: false
  };

  private get statusMap() {
    return ["available", "possibly_used", "returned"]
      .map((status) => ({ value: status, text: this.$t(`stock.status.${status}`) as string }));
  }

  async mounted() {
    await this.refresh();
  }

  private isSelectedActionable(
    items: StockItemModel[],
    check: StockItemActionable,
    matchAll: boolean = true,
  ): boolean {
    let matchCount: number = 0;
    items.forEach((item) => {
      switch (check) {
        case StockItemActionable.Returnable:
          if (item.status != StockItemStatus.Returned) {
            matchCount++;
          }
          break;
      }
    });

    return matchAll ? matchCount == items.length : matchCount > 0;
  }

  private async refresh() {
    this.isLoading = true;
    try {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      const [items, total] = await this.stockService.getMany(
        page,
        itemsPerPage,
        this.filter,
        new Map([[StockOrderBy.$updatedAt, OrderByMode.Desc]]),
      );

      this.total = total;
      this.items = [...items];
    } finally {
      this.isLoading = false;
    }
  }

  private async reset() {
    this.options.page = 1;
    await this.refresh();
  }

  private resolveStatus(raw: string): string {
    const match = this.statusMap.find(i => i.value == raw);
    return match ? match.text : raw;
  }

  @Watch("options", { deep: true })
  private async onOptionsChange(val: any, oldVal: any) {
    await this.refresh();
  }

  @Emit('mark-as-returned')
  markAsReturned(items: StockItemModel[]) {
    return items;
  }
}

export default StockItemsTableExpandedCard;
